export default __webpack_public_path__ + "media/src/assets/images/fileIcon-840d835451bb23f7433a46019b6ec319.png";